import NetInfo from '@react-native-community/netinfo';
import { useEffect, type ReactNode } from 'react';
import { AppState } from 'react-native';

import { processOutbox } from './outbox-service';

export function OfflineSyncProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const unsubscribeNetInfo = NetInfo.addEventListener((state) => {
      if (state.isConnected && state.isInternetReachable !== false) {
        void processOutbox();
      }
    });
    const appStateSubscription = AppState.addEventListener(
      'change',
      (nextState) => {
        if (nextState === 'active') {
          void processOutbox();
        }
      },
    );
    const interval = setInterval(() => {
      void processOutbox();
    }, 30_000);

    void processOutbox();

    return () => {
      unsubscribeNetInfo();
      appStateSubscription.remove();
      clearInterval(interval);
    };
  }, []);

  return children;
}
